<section class="page-section" id="login">
  <div class="extra-background">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Register</h2>
        </div>
      </div>
      <form [formGroup]="registerForm" (submit)="submitForm()">
        <div class="row">
            <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Name</mat-label>
                  <input matInput placeholder="enter email...." formControlName="name" name="name" type="text" />
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Surname</mat-label>
                  <input matInput placeholder="enter email...." formControlName="surname" name="surname" type="text" />
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Phone</mat-label>
                  <input matInput placeholder="enter email...." formControlName="phone" name="phone" type="text" />
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>Email</mat-label>
                  <input matInput placeholder="enter email...." formControlName="email" name="email" type="email" />
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label>password</mat-label>
                  <input matInput type="password" placeholder="enter password...." formControlName="password" name="password" (change)="updatepasswordValidation('confirmPassword')"/>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance='outline'>
                  <mat-label> Confirm Password</mat-label>
                  <input matInput type="password" placeholder="enter password...." formControlName="confirmPassword" name="confirmPassword" (input)="updatepasswordValidation('password')"   />
                </mat-form-field>
            </div>
        </div>
        <button mat-ripple class="btn btn-fsp mb-3">Register</button>

        <a routerLink="/login" class="float-right">login</a>
      </form>
    </div>
  </div>
</section>
